<div class="flex gap-2 align-items-center">
    <app-select-input
        [staticOptions]="$any(store.items$ | async)"
        [form]="form"
        [id]="id"
        label="workplace.label"
        valueKey="id"
        [filterBy]="'name'"
        [autoDisplayFirst]="true"
        [disabled]="disabled"
        class="workplace-select-input">
        <ng-template #item let-data>
            {{ data.name }}
        </ng-template>
        <ng-template #selectedItem let-data>
            {{ data.name }}
        </ng-template>
    </app-select-input>
</div>
